import React, { useContext, useEffect, useMemo, useReducer } from 'react'
import { Typography, Button, message, Row, Col } from 'antd'
import { createApiDataFromForm, handleMyTax, simpleReducer } from '../../../../helper'
import './TaxServiceStep.css'
import { profileScreen } from '../../../../translates'
import { AppConfig, individual, selfEmployed } from '../../../../AppConfig'
import { flowV2Steps } from '../ProfileV2'
import {
  useMutateConfirmMyTaxBind,
  useMutateConfirmMyTaxStatus
} from '../../../../api/react-query/partners'
import { useStores } from '../../../../Store/Store'
import { ConfigContext } from '../../../../context/configContext'
import CheckingData from '../../CheckingData'
// import { nbsp } from '../../../../Constants'
import ActiveSelfEmployedStatus from '../../SelfEmployedStatus/ActiveSelfEmployedStatus'
import InActiveSelfEmployedStatus from '../../SelfEmployedStatus/InActiveSelfEmployedStatus'
import ChangeFioSMZ from '../../SelfEmployedStatus/ChangeFioSMZ'
import WaitingPartnerConsent from '../../SelfEmployedStatus/WaitingPartnerConsent'
import StatusConfirmation from '../../SelfEmployedStatus/StatusConfirmation'

const { Title } = Typography
const { smzErrorCodes, smzRequiredActions } = AppConfig

export const taxServiceSteps = {
  fail: 'fail',
  processing: 'processing',
  lastStepSelfEmployed: 'lastStepSelfEmployed',
  lastStepPartner: 'lastStepPartner',
  changeFIOatFNS: 'changeFIOatFNS', // Просим изменить фио на сайте фнс
  fnsCreating: 'fnsCreating',
  waitingPartnerConsent: 'waitingPartnerConsent',
  statusConfirmation: 'statusConfirmation'
}

const initialState = {
  currentStep: null
}

function TaxServiceStep ({
  profile,
  step,
  onUpdateProfile,
  form,
  setFlowStep,
  doFetchProfileCheck,
  handleUpdateScreen
}) {
  const { partnerProfile } = useStores()
  const { setConfig } = useContext(ConfigContext)
  const [state, setState] = useReducer(simpleReducer, initialState)

  const {
    data: dataTaxStatus,
    mutate: confirmTaxStatus,
    isSuccess: isSuccessTaxStatus,
    isError: isErrorTaxStatus,
    isLoading: isLoadingTaxStatus
  } = useMutateConfirmMyTaxStatus()

  const {
    data: dataTaxBind,
    mutate: confirmTaxBind,
    isSuccess: isSuccessTaxBind,
    isError: isErrorTaxBind,
    isLoading: isLoadingTaxBind
  } = useMutateConfirmMyTaxBind()

  useEffect(() => {
    if (isSuccessTaxStatus && dataTaxStatus?.isSuccess) {
      message.success('Запрос отправлен')
      if (
        dataTaxStatus?.partner?.profile?.smz?.requiredAction === profile?.smz?.requiredAction &&
        dataTaxStatus?.partner?.profile?.smz?.errorCode === profile?.smz?.errorCode
      ) {
        showMessageError({
          requiredAction: dataTaxStatus?.partner?.profile?.smz?.requiredAction,
          errorCode: dataTaxStatus?.partner?.profile?.smz?.errorCode
        })
      }
      partnerProfile.setPartnerProfile(dataTaxStatus?.partner)
      handleUpdateScreen && handleUpdateScreen(dataTaxStatus?.partner?.profile)
    } else if (isErrorTaxStatus || dataTaxStatus?.errorMessage) {
      message.error(dataTaxStatus?.errorMessage || 'Ошибка запроса проверки статуса')
    }
  }, [isSuccessTaxStatus, isErrorTaxStatus, dataTaxStatus])

  useEffect(() => {
    if (isSuccessTaxBind && dataTaxBind?.isSuccess) {
      if (!dataTaxBind?.partner?.profile?.smz?.errorCode !== smzErrorCodes.requestNotProcessed) {
        message.success('Запрос отправлен')
      }
      partnerProfile.setPartnerProfile(dataTaxBind?.partner)
      handleUpdateScreen && handleUpdateScreen(dataTaxBind?.partner?.profile)
    } else if (isErrorTaxBind || dataTaxBind?.errorMessage) {
      message.error(dataTaxBind?.errorMessage || 'Ошибка запроса подтверждения партнерства')
    }
  }, [isSuccessTaxBind, isErrorTaxBind, dataTaxBind])

  useEffect(() => {
    setConfig({
      loadingData: {
        isLoadingFlowV2: isLoadingTaxStatus || isLoadingTaxBind,
        loadingText: (
          <>
            Проверяем данные.
            <br />
            Это может занять какое-то время.
          </>
        )
      }
    })
  }, [isLoadingTaxStatus, isLoadingTaxBind, setConfig])

  const showMessageError = ({ requiredAction, errorCode }) => {
    if (
      requiredAction === smzRequiredActions.ConfirmSmz &&
      [smzErrorCodes.unregistered, smzErrorCodes.partnerUnregistered].includes(errorCode)
    ) {
      message.error({
        content: (
          <>
            <b>Вы пока не встали на учет в качестве самозанятого</b>
            <br />
            Пожалуйста перейдите в приложении «Мой налог» и выполните шаги согласно инструкции
          </>
        ),
        duration: 5
      })
    }
  }

  const onActionSelfEmployed = () => {
    onUpdateProfile({
      info: {
        personalData: {
          [profileScreen.input.legalForm.name]: selfEmployed
        },
        markFilled: true
      }
    })
  }

  const onActionIndividual = () => {
    form?.setFieldsValue({
      personalData: {
        [profileScreen.input.legalForm.name]: individual
      }
    })
    const values = form.getFieldsValue()
    values.personalData = {
      ...partnerProfile?.profile.personalData,
      [profileScreen.input.legalForm.name]: individual
    }
    const info = createApiDataFromForm(values)
    doFetchProfileCheck({ info })
    setFlowStep({ currentStep: flowV2Steps.innStep })
  }

  useEffect(() => {
    setState({ currentStep: step })
  }, [step])

  const content = useMemo(() => {
    const list = {
      [taxServiceSteps.fail]: (
        <TaxServiceFail
          onActionSelfEmployed={onActionSelfEmployed}
          onActionIndividual={onActionIndividual}
        />
      ),
      [taxServiceSteps.processing]: <CheckingData />,
      [taxServiceSteps.lastStepSelfEmployed]: (
        <ActiveSelfEmployedStatus onClick={confirmTaxStatus} loading={isLoadingTaxStatus} />
      ),
      [taxServiceSteps.lastStepPartner]: (
        <InActiveSelfEmployedStatus onClick={confirmTaxBind} loading={isLoadingTaxBind} />
      ),
      [taxServiceSteps.changeFIOatFNS]: (
        <ChangeFioSMZ loading={isLoadingTaxBind} handleUpdateScreen={handleUpdateScreen} />
      ),
      [taxServiceSteps.waitingPartnerConsent]: (
        <WaitingPartnerConsent loading={isLoadingTaxBind} handleUpdateScreen={handleUpdateScreen} />
      ),
      [taxServiceSteps.statusConfirmation]: (
        <StatusConfirmation loading={isLoadingTaxBind} handleUpdateScreen={handleUpdateScreen} />
      )
    }
    return list[state.currentStep] || null
  }, [state.currentStep, isLoadingTaxStatus, confirmTaxStatus])

  return <div className='tax-service-step'>{content}</div>
}

function TaxServiceFail ({ onActionSelfEmployed, onActionIndividual }) {
  const onClickLater = () => {
    onActionSelfEmployed?.()
  }
  const onIndividual = () => {
    onActionIndividual?.()
  }
  return (
    <Row className='flex-column TaxService'>
      <Col span={24} className='info-block'>
        <Row>
          <Col>
            <Title level={3}>Не удалось получить данные</Title>
            <ul>
              <li>Если у вас есть статус самозанятого — его можно подтвердить позже</li>
              <li>Если у вас нет статуса самозанятого — получите его в приложении «Мой налог»</li>
              <li>Вы также можете пройти оформление в качестве ИП</li>
            </ul>
          </Col>
          <Col span={24}>
            <img src='/img/alert-yellow.png' />
          </Col>
        </Row>
      </Col>
      <Col span={24} className='btn-block'>
        <Button block type='success' onClick={onClickLater} className='later-btn'>
          Подтвердить позже
        </Button>
        <Button block className='btn-my-tax' onClick={handleMyTax}>
          <img src='/img/fns.png' />
          Перейти в «Мой налог»
        </Button>
        <Button block onClick={onIndividual}>
          Оформиться как ИП
        </Button>
      </Col>
    </Row>
  )
}

export default TaxServiceStep
